module.exports = __webpack_public_path__ + "static/img/merveilleux_shadow.942d532.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/merveilleux_shadow.png
// module id = zyAM
// module chunks = 0